import {
  Component, Input,
} from '@angular/core';
import { ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { selectCurrentSite } from '../../../features/site/site.selectors';
import { first } from 'rxjs';
import { Site } from '../../../models/site';
import {
  addTrackerComment,
  addTrackerCommentFailure,
  addTrackerCommentSuccess, loadTrackerComments,
  loadTrackerCommentsSuccess
} from '../../../features/tracker/tracker.actions';
import { HistoryChannelComponents } from './history-channel.components';
import {
  newCommentReceived
} from '../../../features/websocket/websocket.actions';
import { Deserialize } from 'cerialize';
import { Comment } from '../../../models/comment';
import { User } from '../../../models/user';


@Component({
    selector: 'tracker-history-channel',
    templateUrl: './history-channel.component.html',
    styleUrls: ['./history-channel.component.scss'],
    standalone: false
})
export class TrackerHistoryChannelComponents extends HistoryChannelComponents {

  override initHandleComments(): void {
    this.actions.pipe(ofType(loadTrackerCommentsSuccess), takeUntilDestroyed())
      .subscribe(result => {
        this.comments = Object.assign([], result.comments);
        this.scrollToBottom();
        this.isLoading = false;
      });
    this.actions.pipe(ofType(addTrackerCommentSuccess), takeUntilDestroyed())
      .subscribe(result => {
        this.comments.push(result.comment);
        this.scrollToBottom();
        this.clearEditor();
      });
    this.actions.pipe(ofType(addTrackerCommentFailure), takeUntilDestroyed())
      .subscribe(result => {
        this.toastr.error(this.translocoService.translate("add_comment_failure"));
        this.clearEditor();
      });
    this.actions.pipe(ofType(newCommentReceived), takeUntilDestroyed())
      .subscribe(result => {
        if (result.comment) {
          const comment = Deserialize(result.comment, Comment);
          this.user$
            .pipe(first())
            .subscribe((user: User | undefined) => {
            if (user?.name !== comment.author) {
              if (comment.targetId === this.itemId) {
                this.comments.push(comment);
                this.scrollToBottom();
              }
            }
          });
        }
      });
  }

  override loadComments() {
    this.store.select(selectCurrentSite)
      .pipe(first())
      .subscribe((site: Site | null | undefined) => {
        if (site && this.itemId) {
          this.isLoading = true;
          this.store.dispatch(loadTrackerComments({
            organizationId: site.organization,
            siteId: site.id,
            trackerId: this.itemId,
          }))
        }
      });
  }

  override onClickAddComment(fileNames: string[]): void {
    this.store.select(selectCurrentSite)
      .pipe(first())
      .subscribe((site: Site | null | undefined) => {
        if (site && this.itemId && this.textareaRef) {
          const payload: any = {'text': this.textareaRef.nativeElement.value};
          if (fileNames.length > 0) {
            payload.metadata = {
              site: site.id,
              attachments: fileNames
            };
          }
          this.store.dispatch(addTrackerComment({
            organizationId: site.organization,
            siteId: site.id,
            trackerId: this.itemId,
            payload
          }))
        }
      });
  }
}
